<template>
  <div class="container container-fluid mt-3">
    <div v-if="showComponentData" class="row">
      <h4>Tipo de cobertura</h4>
      <!-- FRENTE DE POLIZA -->
      <div v-if="isFieldVisible('photo_insurance_certificate_front_file')" class="col-md-4">
        <div>
          <div class="form-group bordered">
            <label for="photo_insurance_certificate_front_file" class="form-label text-left">{{ getFieldDescription('photo_insurance_certificate_front_file') }}</label>
          </div>
          <div>
            <div>
                <div @click="openCamera('photo_insurance_certificate_front_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_insurance_certificate_front_file'"
                  :id="'photo_insurance_certificate_front_file'"
                  style="display: none;"
                  @change="onFileChange('photo_insurance_certificate_front_file')"
                />
              </div>
          </div>
          <div class="btn tbn-block btn-custom mt-3" v-if="photo_insurance_certificate_front_file" @click="openImageModal(photo_insurance_certificate_front_file)">Ver Imagen</div>
        </div>
      </div>
      <!-- DORSO DE POLIZA -->
      <div v-if="isFieldVisible('photo_insurance_certificate_back_file')" class="col-md-4">
        <div>
          <div class="form-group bordered">
            <label for="photo_insurance_certificate_back_file" class="form-label text-left">{{ getFieldDescription('photo_insurance_certificate_back_file') }}</label>
          </div>
          <div> 
            <div>
                <div @click="openCamera('photo_insurance_certificate_back_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_insurance_certificate_back_file'"
                  :id="'photo_insurance_certificate_back_file'"
                  style="display: none;"
                  @change="onFileChange('photo_insurance_certificate_back_file')"
                />
              </div>
          </div>
          <div class="btn btn-block btn-custom mt-3" v-if="photo_insurance_certificate_back_file" @click="openImageModal(photo_insurance_certificate_back_file)">Ver Imagen</div>
        </div>
      </div>
    </div>
    
    <!-- MODAL -->
    <ShowImagesModal
    :modalId="'imageModalPhotoInsuranceCertificate'"
    :currentImage="currentImage"
    :currentImageName="currentImageName"
    />
  
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import ShowImagesModal from '../../modals/ShowImages';
import ImageCompressor from 'image-compressor.js'; 
import { rotateImageIfNeeded } from '../../../Utils/imageUtils';  

export default {
  name: 'FormPhotoInsuranceCertificate',
  props: {
    data: Object,
  },
  components: {
    ShowImagesModal,
  },
  emits: ['formDataChanged'],
  setup(props, { emit }) {
    const dataCompany = ref(props.data.dataCompaniesForms);
    const dataFormsField = ref(props.data.dataFormsField);
    const showComponentData = ref(false);
    const currentImage = ref(null);
    const currentImageName = ref('');

    const photo_insurance_certificate_front_file = ref(null);
    const photo_insurance_certificate_back_file = ref(null);

    const formData = ref({
      photo_insurance_certificate_front_file_id: photo_insurance_certificate_front_file.value,
      photo_insurance_certificate_back_file_id: photo_insurance_certificate_back_file.value,
    });

    const cargarDatos = () => {
      try {
        showComponentData.value = (
          dataCompany.value &&
          (dataCompany.value.photo_insurance_certificate_front_file || dataCompany.value.photo_insurance_certificate_back_file)
        );
      } catch (error) {
        console.error(error);
      }
    };

    const isFieldVisible = (fieldName) => {
      return dataCompany.value && dataCompany.value[fieldName] === 1;
    };

    const getFieldDescription = (fieldNameLabel) => {
      let description = fieldNameLabel;
      const dataFormsFieldsWithData = Object.values(dataFormsField.value);
 
      dataFormsFieldsWithData[0].forEach((entry) => {
        const field = entry;
 
        if (field.name === fieldNameLabel) {
          description = field.description;
        }
      });
      return description;
    };

    const openImageModal = (imageFile) => {
      currentImage.value = URL.createObjectURL(imageFile);
      currentImageName.value = imageFile.name;
      $('#imageModalPhotoInsuranceCertificate').modal('show');
    };

    const onFileChange = async (fieldName) => {
      const fileFields = {
        photo_insurance_certificate_front_file: photo_insurance_certificate_front_file,
        photo_insurance_certificate_back_file: photo_insurance_certificate_back_file,
      };

      const fileInput = document.getElementById(fieldName);

      try {
        const rotatedFile = await rotateImageIfNeeded(fileInput.files[0], 90);
        const compressedFile = await compressImage(rotatedFile);
        fileFields[fieldName].value = compressedFile;
        emitFieldChanged();
      } catch (error) {
        console.error('Error al comprimir la imagen:', error);
      }
    };

    const compressImage = (file) => {
      return new Promise((resolve, reject) => {
        const compressor = new ImageCompressor();
        compressor.compress(file, {
          maxWidth: 800,
          maxHeight: 600,
          quality: 1,
          mimeType: 'image/jpeg',
          success(result) {
            resolve(result);
          },
          error(error) {
            reject(error);
          },
        });
      });
    };

    const emitFieldChanged = () => {
      const formFields = {
        photo_insurance_certificate_front_id: photo_insurance_certificate_front_file.value,
        photo_insurance_certificate_back_id: photo_insurance_certificate_back_file.value,
      };
      
      const validFields = {};
      for (const [key, value] of Object.entries(formFields)) {
        if (dataCompany.value && dataCompany.value[key.replace('_id', '_file')]) {
          validFields[key] = value;
        }
      }

      formData.value = validFields;
      emit('formDataChanged', formData.value);
    };

    const openCamera = async (fieldName) => {
      try {
        const inputElement = document.getElementById(fieldName);
        inputElement.click();
      } catch (error) {
        console.error('Error al abrir la ventana de selección de archivo:', error);
      }
    };

    onMounted(cargarDatos);

    return {
      dataCompany,
      showComponentData,
      isFieldVisible,
      getFieldDescription,
      dataFormsField,
      openImageModal,
      onFileChange,
      currentImage,
      currentImageName,
      emitFieldChanged,
      formData,
      photo_insurance_certificate_front_file,
      photo_insurance_certificate_back_file,
      openCamera,
    };
  },
};
</script>

